import { escapeRegExp } from './regExpHelpers';

export const PRICE_SEPARATOR = '.';

export const formatInputValueToPrice = (value: string) => {
  const separator = escapeRegExp(PRICE_SEPARATOR);

  let inputValue = value.replace(new RegExp(`[^0-9${separator}]`, 'g'), '');

  const parts = inputValue.split('.');
  if (parts.length > 2) {
    inputValue = parts[0] + '.' + parts[1];
  }

  if (parts[1]?.length > 2) {
    inputValue = parts[0] + '.' + parts[1].slice(0, 2);
  }

  return inputValue;
};

export const formatPrice = (
  value: string,
  locale = 'en-US',
  currency = 'USD',
) => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  }).format(Number(value));
};
